if (!customElements.get("variant-label")) {
  class t extends HTMLElement {
    constructor() {
      super(), this.variantLabels = this.querySelectorAll(".js-variant-label"), window
        .initLazyScript(this, this.initLazySection.bind(this))
    }
    initLazySection() {
      if (this.variantLabels) {
        let t = this.closest(".product").querySelector("variant-picker");
        t && t.addEventListener("on:variant:change", this.handleVariantChange.bind(this)), this
          .dataset.currentVariantId && this.setVisibleVariantLabel(this.dataset.currentVariantId)
      }
    }
    setVisibleVariantLabel(t) {
      this.variantLabels.forEach(a => {
        a.hidden = a.dataset.variantId.toString() !== t.toString()
      })
    }
    handleVariantChange(t) {
      t.detail.variant && this.setVisibleVariantLabel(t.detail.variant.id)
    }
  }
  customElements.define("variant-label", t)
}
